export const getActions = (email, enviadoA) => {
    const actions = {
        actions: [
            {
                label: 'Editar Descuento',
                icon: 'edit',
                action: 'edit',
            },
        ],
        extra: [],
    };

    if (email) {
        actions.actions.push(
            {
                label: 'Email prueba',
                icon: 'email-test',
                action: 'email-test',
            },
        );

        const enviadoATodos = enviadoA?.includes('Todos');
        if (!enviadoATodos) {
            actions.actions.push({
                label: 'Email clientes',
                icon: 'send',
                action: 'email',
            });
        }
    }

    return actions;
};
